import { defineStore } from 'pinia'
import api from '@/api/httpRequest'
import storage from '@/api/storage'

export const useAuthStore = defineStore('auth', () => {
  const storedSession = storage.GET('r1_session')
  const authUser = ref(storedSession || null)

  // getters
  const user = computed(() => authUser.value)
  const isLoggedIn = computed(() => !!authUser.value && !!authUser.value.token)
  const authHeader = computed(() => {
    if (isLoggedIn.value) {
      return {
        Authorization: `${authUser.value.login}:${authUser.value.token}:${authUser.value.session}`,
      }
    }
    return {}
  })

  // actions
  async function login(userCredentials) {
    const { data } = await api.post('auth-login', { headers: {}, requestParam: userCredentials })
    const { group, login, session, token, user_id } = data
    storage.SET('r1_session', { group, login, session, token, user_id })
    authUser.value = { group, login, session, token, user_id }
  };

  function logout() {
    storage.REMOVE('r1_session')
    authUser.value = null
  };

  return {
    authUser,
    user,
    isLoggedIn,
    authHeader,
    login,
    logout,
  }
})
